// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__KpZwQ","content":"style_content__9eole","title":"style_title__D1bES","description":"style_description__gATjo","bottom":"style_bottom__vlAuq"};